<!-- 账期管理 -->
<template>
  <div class="pdPeriodList">
    <sirui-search
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
    >
    </sirui-search>
    <!-- 表格 -->
    <div class="main-content">
      <vxe-toolbar>
        <template v-slot:buttons>
          <template v-for="item in menuButtonList">
            <vxe-button
              type="primary"
              :icon="item.attributes.buttonStyle"
              :style="
                'background-color:' +
                (item.label == '删除' || item.label == '禁用' ? '#FE8783' : 'rgb(98, 153, 254)') +
                ';border:1px solid ' +
                (item.label == '删除' || item.label == '禁用' ? '#FE8783' : 'rgb(98, 153, 254)')
              "
              :key="item.id"
              @click="chooseClick(item.attributes.buttonUrl, item)"
              >{{ item.label }}</vxe-button
            >
          </template>
        </template>
      </vxe-toolbar>
      <vxe-grid
        border
        show-overflow
        resizable
        ref="table"
        class="vxe-table-element"
        size="mini"
        align="left"
        column-min-width="120"
        :loading="load"
        :auto-resize="true"
        :data="tableData"
        :columns="columnList"
        :edit-rules="rules"
        @select-change="handleSelectionChange"
        @select-all="handleSelectionChange"
      >
      </vxe-grid>
      <!-- 分页 -->
      <div class="pagination">
        <el-pagination
          ref="page"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page.pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-count="page.pages"
          :page-size="page.pageSize"
          :total="page.total"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import API from '@/api/productCenter/pdPeriod';
  import SiruiSearch from '@/components/SiruiSearch';
  export default {
    name: 'pdPeriodList',
    components: {
      SiruiSearch,
    },
    computed: {
      searchColumns() {
        return [
          {
            // 项目名称
            prop: 'projectCode',
            name: this.$t('pdPeriod.column.projectName'),
            type: 'dict',
            dictType: 'produce_product_proname',
          },
          {
            // 账期状态
            prop: 'periodStatus',
            name: this.$t('pdPeriod.column.periodStatus'),
            type: 'dict',
            dictType: 'pdPeriodStatus',
          },
          {
            // 日期从
            prop: 'startDate',
            name: this.$t('pdPeriod.column.startDate'),
            type: 'startDaterangePicker',
          },
          {
            // 日期至
            prop: 'endDate',
            name: this.$t('pdPeriod.column.endDate'),
            type: 'endDaterangePicker',
          },
        ];
      },
      columnList() {
        return [
          { type: 'checkbox', width: 50 },
          {
            // 项目名称
            field: 'projectCode',
            title: this.$t('pdPeriod.column.projectName'),
            editRender: {
              name: 'ElSelect',
              options: this.$baseRequest.getDictListMapByType('produce_product_proname'),
              props: {
                clearable: true,
                filterable: true,
              },
            },
          },
          {
            // 账期名称
            field: 'periodName',
            title: this.$t('pdPeriod.column.periodName'),
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
          },
          {
            // 日期从
            field: 'startDate',
            title: this.$t('pdPeriod.column.startDate'),
            editRender: {
              name: 'ElDatePicker',
              props: {
                clearable: true,
                valueFormat: 'yyyy-MM-dd',
              },
            },
          },
          {
            // 日期至
            field: 'endDate',
            title: this.$t('pdPeriod.column.endDate'),
            editRender: {
              name: 'ElDatePicker',
              props: {
                clearable: true,
                valueFormat: 'yyyy-MM-dd',
              },
            },
          },
          {
            // 账期状态
            field: 'periodStatus',
            title: this.$t('pdPeriod.column.periodStatus'),
            formatter: this.formatterStatus,
          },
        ];
      },
    },
    data() {
      return {
        menuButtonList: [], // 按钮
        load: false,
        tableData: [],
        multipleSelection: [],
        query: {
          projectCode: null, // 项目名称
          periodStatus: null, // 账期状态
          startDate: null, // 日期从
          endDate: null, // 日期至
        },
        page: {
          pages: 0,
          pageSize: 10,
          pageNum: 1,
          total: 0,
        },
        rules: {
          projectCode: [
            {
              required: true,
              message: this.$t('pdPeriod.placeholder.projectName'),
              trigger: ['blur', 'change'],
            },
          ],
          periodName: [
            {
              required: true,
              message: this.$t('pdPeriod.placeholder.periodName'),
              trigger: ['blur', 'change'],
            },
          ],
          startDate: [
            {
              required: true,
              message: this.$t('pdPeriod.placeholder.startDate'),
              trigger: ['blur', 'change'],
            },
          ],
          endDate: [
            {
              required: true,
              message: this.$t('pdPeriod.placeholder.endDate'),
              trigger: ['blur', 'change'],
            },
          ],
        },
      };
    },
    mounted() {
      this.getData();
      this.getButtonList();
    },
    methods: {
      async getData() {
        this.load = true;
        const { pageNum, pageSize } = this.page;
        const params = { ...this.query, pageNum, pageSize };
        let res = await this.$axios.post(API.QUERY_PDPERIOD_PAGE, params);
        if (res) {
          this.load = false;
          if (res.data.code == 0) {
            this.tableData = res.data.data.records;
            this.page.total = res.data.data.total;
          }
        }
      },
      formatterStatus({ cellValue }) {
        return this.$baseRequest.getDictValueByType('pdPeriodStatus', cellValue);
      },
      chooseClick(type) {
        if (type == 'add') {
          this.handleAdd();
        } else if (type == 'edit') {
          this.handleEdit();
        } else if (type == 'save') {
          this.handleSave();
        } else if (type == 'del') {
          this.handleDel();
        } else if (type == 'open' || type == 'close') {
          this.handleOperate(type);
        }
      },
      handleAdd() {
        let path = {
          path: '/production/pdPeriodAdd',
          name: 'pdPeriodAdd',
          meta: {
            keepAlive: true,
          },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      handleEdit() {
        // 编辑
        let selectRecords = this.$refs.table.getCheckboxRecords();
        if (this.multipleSelection.length > 0) {
          this.multipleSelection.forEach((item) => {
            this.$refs.table.setActiveRow(item);
          });
          this.$refs.table.validate(selectRecords).catch((errMap) => errMap); //修改校验
        } else {
          this.$message({
            showClose: true,
            message: this.$t('pdPeriod.message.select'),
            type: 'error',
          });
        }
      },
      handleDel() {
        // 删除
        if (this.multipleSelection.length == 0) {
          return this.$message({
            showClose: true,
            type: 'error',
            message: this.$t('message.noData'),
          });
        }
        let ids = this.multipleSelection.map((item) => {
          return item.id;
        });
        this.$confirmAction()
          .then(() => {
            this.commonRequest('DELETE_PDPERIOD', ids);
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      handleOperate(type) {
        // 打开、关闭期间
        if (this.multipleSelection.length == 0) {
          return this.$message({
            showClose: true,
            type: 'info',
            message: this.$t('message.noData'),
          });
        }
        let canOperItems = [];
        this.multipleSelection.map((item) => {
          if (item.periodStatus == `${type == 'open' ? 'clos' : 'open'}ed`) {
            canOperItems.push(item);
          }
        });
        if (canOperItems.length == 0)
          return this.tips(type == 'open' ? 'cannotOpen' : 'cannotClose', 'error');
        let ids = canOperItems.map((i) => i.id);
        let message =
          ids.length != this.multipleSelection.length
            ? this.$t(`pdPeriod.message.${type == 'open' ? 'hasCannotOpen' : 'hasCannotClose'}`)
            : '';
        this.$confirmAction(
          this.$t(`pdPeriod.message.${type == 'open' ? 'isOpenConfirm' : 'isCloseConfirm'}`),
          message
        )
          .then(() => {
            this.commonRequest(type == 'open' ? 'OPEN_PDPERIOD' : 'CLOSE_PDPERIOD', ids);
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      async handleSave() {
        let tableData = await this.exportChildData();
        if (tableData) {
          this.commonRequest('SAVE_PDPERIOD', tableData);
        }
      },
      commonRequest(apiName, params) {
        this.loading.startLoading();
        this.$axios.post(API[apiName], params).then((res) => {
          this.loading.endLoading();
          if (0 == res.data.code) {
            this.$message({ showClose: true, message: res.data.msg, type: 'success' });
            this.resetBtnClick();
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      getButtonList() {
        //获取菜单按钮
        this.getButtons().then((res) => {
          this.menuButtonList = res;
          // this.menuButtonList.splice(this.menuButtonList.findIndex(e => e.attributes.buttonUrl === 'edit'),1);
        });
      },
      handleSelectionChange(val) {
        // 选中事件
        this.multipleSelection = val.selection;
      },
      searchBtnClick() {
        this.resetBtnClick();
      },
      resetBtnClick() {
        // 重置
        this.page.pages = 0;
        this.page.pageSize = 10;
        this.page.pageNum = 1;
        this.page.total = 0;
        this.multipleSelection = [];
        this.$refs.table.clearCheckboxReserve();
        this.getData();
      },
      handleSizeChange(value) {
        this.page.pageSize = value;
        this.getData();
      },
      handleCurrentChange(value) {
        this.page.pageNum = value;
        this.getData();
      },
      exportChildData() {
        // 返回数据
        const [...tableData] = this.$refs.table.getTableData().fullData;
        return new Promise((resolve) => {
          this.$refs.table.validate().then(() => {
            resolve(tableData);
          });
        });
      },
      // 提示
      tips(info) {
        this.$message({
          showClose: true,
          message: this.$t(`pdPeriod.message.${info}`),
          type: 'error',
        });
      },
    },
  };
</script>
